export default __webpack_public_path__ + "static/media/spooky_hill_m2.f6924658.png";